const TABS = [
  { id: 'overview',       label: 'Overview',       step: 1 },
  { id: 'project-sizing', label: 'Project Sizing', step: 2 },
  { id: 'sources-uses',   label: 'Sources & Uses', step: 3 },
  { id: 'structure',      label: 'Structure',      step: 4 },
  { id: 'net-benefit',    label: 'Net Benefit',    step: 5 },
  { id: 'unwind',         label: 'Unwind',         step: 6 },
  { id: 'how-to-start',   label: 'Get Started',    step: 7 },
];

export default function TabNav({ activeTab, onTabChange }) {
  const activeStep = TABS.find((t) => t.id === activeTab)?.step ?? 1;

  return (
    <div className="bg-white border-b border-gray-200">
      {/* Mobile: step indicator strip */}
      <div className="flex items-center justify-between px-4 py-1.5 border-b border-gray-100 sm:hidden">
        <span className="text-xs text-gray-400 font-medium">
          Step {activeStep} of {TABS.length}
        </span>
        <span className="text-xs font-semibold text-emerald-700">
          {TABS.find((t) => t.id === activeTab)?.label}
        </span>
      </div>

      {/* Tab bar — scrollable */}
      <nav
        className="flex overflow-x-auto"
        style={{ WebkitOverflowScrolling: 'touch', scrollbarWidth: 'none' }}
        role="tablist"
        aria-label="Calculator sections"
      >
        {TABS.map(({ id, label, step }) => {
          const isActive = activeTab === id;
          return (
            <button
              key={id}
              role="tab"
              aria-selected={isActive}
              onClick={() => onTabChange(id)}
              className={[
                'flex items-center gap-1.5 px-4 py-3.5 text-sm font-medium whitespace-nowrap shrink-0 transition-colors border-b-2 focus:outline-none',
                isActive
                  ? 'text-emerald-700 border-emerald-700'
                  : 'text-gray-500 border-transparent hover:text-gray-800 hover:border-gray-300',
              ].join(' ')}
            >
              <span
                className={[
                  'w-5 h-5 rounded-full text-xs font-bold flex items-center justify-center shrink-0',
                  isActive ? 'bg-emerald-700 text-white' : 'bg-gray-100 text-gray-500',
                ].join(' ')}
              >
                {step}
              </span>
              <span className="hidden sm:inline">{label}</span>
              <span className="sm:hidden text-xs">{label}</span>
            </button>
          );
        })}
      </nav>
    </div>
  );
}
